import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import style from "../../../../sass/pages/shipments/shipments-list.module.scss";
import {
    openCreatePopupWithChangingData,
} from "../../shipmentsSlice";
import { selectUser } from "../../../user/userSlice";
import { pushAlert } from "../../../alerts/alertSlice";
import { validateUser } from "../../../../validators/validateUser";
import SendedFilter from "./SendedFilter";
import { useTranslation } from "react-i18next";

const Buttons = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(selectUser);

    const handleCreateButtonClick = () => {
        const errors = validateUser(user);
		if (errors && errors.length > 0) {
			dispatch(pushAlert({
				type: "warning",
				message: t("shipments.errors.user_data_not_filled"),
				delay: 2000,
			}));
			return;
		}
        dispatch(
            openCreatePopupWithChangingData({
                senderCityCode: user["sender-city-code"],
                senderTownID: user["sender-town-id"],
                senderDistrictID: user["sender-district-id"],
            }),
        );
    };

    return (
        <div className="flex justify-start sm:justify-between flex-col-reverse sm:flex-row h-fit gap-y-4 gap-x-8 w-full">
            <SendedFilter />
            <Button
                variant="contained"
                sx={{
                    color: "white",
                    bgcolor: "#059669",
                    fontSize: "0.7rem",
                    maxWidth: "fit-content",
                    ":hover": {
                        bgcolor: "#047857",
                    },
                }}
                className={`${style["btn"]} ${style["btn-primary"]} text-sm xl:text-base`}
                onClick={handleCreateButtonClick}
            >
                {t("shipments.shipments_list.create_shipment_button")}
            </Button>
        </div>
    );
};

export default Buttons;
